import { render, staticRenderFns } from "./AssignRentPlan.vue?vue&type=template&id=3d38c593&scoped=true&"
import script from "./AssignRentPlan.vue?vue&type=script&lang=js&"
export * from "./AssignRentPlan.vue?vue&type=script&lang=js&"
import style0 from "./AssignRentPlan.vue?vue&type=style&index=0&id=3d38c593&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d38c593",
  null
  
)

export default component.exports